// Generated by GitHub Copilot
import type { TFunction } from 'i18next'
import type Account from '#core/entities/auth/accounts/Account.ts'

/** How an account reads in the user's own settings: the provider, then what identifies it there. */
export function mapLinkedAccountLabel(account: Account, t: TFunction<'settings'>): { title: string; detail: string } {
  if (account.isPassword) return { title: t('security.linkedAccounts.provider.ynteq'), detail: account.identifier }
  if (account.isMicrosoft) return { title: t('security.linkedAccounts.provider.microsoft'), detail: account.identifier }
  return { title: account.authentication_provider, detail: account.identifier }
}
